import { DANGER } from './danger';
import { GREYSCALE } from './greyscale';
import { INFO } from './info';
import { PINK } from './pink';
import { PRIMARY } from './primary';
import { SECONDARY } from './secondary';
import { SUCCESS } from './success';
import { TERTIARY } from './tertiary';
import { WARNING } from './warning';

export const PALETTE = {
  DANGER,
  GREYSCALE,
  INFO,
  PRIMARY,
  SECONDARY,
  SUCCESS,
  TERTIARY,
  WARNING,
  PINK,
} as const;
